// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-module--container--Xg_8o"};